import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminLayout from '../../Components/Admin/AdminLayout';
import {
  getProductRef,
  productsRef,
  serverTimestamp,
} from '../../firebase/collections';

function AdminAds() {
  const { t } = useTranslation();
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [moderationFilter, setModerationFilter] = useState('');

  useEffect(() => {
    let q = productsRef().orderBy('createdAt', 'desc').limit(100);
    if (moderationFilter) {
      q = productsRef()
        .where('moderationStatus', '==', moderationFilter)
        .orderBy('createdAt', 'desc')
        .limit(100);
    }
    q.get()
      .then((snap) => {
        setAds(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch((err) => {
        console.error('AdminAds fetch error:', err);
        setAds([]);
      })
      .finally(() => setLoading(false));
  }, [moderationFilter]);

  const updateModeration = (id, status) => {
    getProductRef(id)
      .update({ moderationStatus: status, updatedAt: serverTimestamp() })
      .then(() => {
        setAds((prev) =>
          prev.map((a) =>
            a.id === id ? { ...a, moderationStatus: status } : a
          )
        );
      });
  };

  return (
    <AdminLayout>
      <h1>{t('admin.ads')}</h1>
      <div className="adminFilters">
        <label>{t('admin.moderation')}: </label>
        <select
          value={moderationFilter}
          onChange={(e) => setModerationFilter(e.target.value)}
        >
          <option value="">{t('admin.all')}</option>
          <option value="pending">{t('admin.pending')}</option>
          <option value="approved">{t('admin.approved')}</option>
          <option value="rejected">{t('admin.rejected')}</option>
          <option value="flagged">{t('admin.flagged')}</option>
        </select>
      </div>
      {loading ? (
        <p>{t('admin.loading')}</p>
      ) : (
        <div className="adminTableWrap">
          <table className="adminTable">
            <thead>
              <tr>
                <th>{t('admin.title')}</th>
                <th>{t('admin.category')}</th>
                <th>{t('admin.status')}</th>
                <th>{t('admin.moderation')}</th>
                <th>{t('admin.reports')}</th>
                <th>{t('admin.user')}</th>
                <th>{t('admin.link')}</th>
                <th>{t('admin.actions')}</th>
              </tr>
            </thead>
            <tbody>
              {ads.map((a) => (
                <tr key={a.id}>
                  <td>{a.name}</td>
                  <td>{a.category}</td>
                  <td>{a.status || 'active'}</td>
                  <td>{a.moderationStatus || 'approved'}</td>
                  <td>{a.reportCount || 0}</td>
                  <td>{a.userId}</td>
                  <td>
                    <Link
                      to={`/ad/${a.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('admin.view')}
                    </Link>
                  </td>
                  <td>
                    {(a.moderationStatus === 'pending' ||
                      a.moderationStatus === 'flagged') && (
                      <>
                        <button
                          type="button"
                          onClick={() => updateModeration(a.id, 'approved')}
                        >
                          {t('admin.approve')}
                        </button>
                        <button
                          type="button"
                          onClick={() => updateModeration(a.id, 'rejected')}
                        >
                          {t('admin.reject')}
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminAds;
